import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import request from '@/router/axios';
export var modelList = function modelList(current, size, params) {
  return request({
    url: '/api/blade-flow/model/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      current: current,
      size: size
    })
  });
};
export var managerList = function managerList(current, size, params) {
  return request({
    url: '/api/blade-flow/manager/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      current: current,
      size: size
    })
  });
};
export var followList = function followList(current, size, params) {
  return request({
    url: '/api/blade-flow/follow/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      current: current,
      size: size
    })
  });
};
export var removeModel = function removeModel(ids) {
  return request({
    url: '/api/blade-flow/model/remove',
    method: 'post',
    params: {
      ids: ids
    }
  });
};
export var deployModel = function deployModel(params) {
  return request({
    url: '/api/blade-flow/model/deploy',
    method: 'post',
    params: params
  });
};
export var changeState = function changeState(params) {
  return request({
    url: '/api/blade-flow/manager/change-state',
    method: 'post',
    params: params
  });
};
export var deployUpload = function deployUpload(category, tenantIds, files) {
  var formData = new FormData();
  formData.append('category', category);
  formData.append('tenantIds', tenantIds);
  files.forEach(function (file) {
    formData.append('files', file);
  });
  return request({
    headers: {
      "Content-Type": "multipart/form-data"
    },
    url: '/api/blade-flow/manager/deploy-upload',
    method: 'post',
    data: formData
  });
};
export var deleteDeployment = function deleteDeployment(deploymentIds) {
  return request({
    url: '/api/blade-flow/manager/delete-deployment',
    method: 'post',
    params: {
      deploymentIds: deploymentIds
    }
  });
};
export var deleteProcessInstance = function deleteProcessInstance(params) {
  return request({
    url: '/api/blade-flow/follow/delete-process-instance',
    method: 'post',
    params: params
  });
};